import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import Card from "@/components/ui/Card";

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

// Page styles using design tokens
const pageStyles = {
  maxW: "6xl",
  mx: "auto",
};

const headerStyles = {
  mb: 2,
};

const subtitleStyles = {
  color: "gray.600",
  _dark: { color: "gray.400" },
};

export default function PlaceholderPage({ 
  title, 
  description = "This page is under construction." 
}: PlaceholderPageProps) {
  return (
    <Box {...pageStyles}>
      <VStack gap={8} align="stretch">
        <Box>
          <Heading size="xl" {...headerStyles}>
            {title}
          </Heading>
          <Text {...subtitleStyles}>
            {description}
          </Text>
        </Box>

        <Card>
          <Text {...subtitleStyles}>
            Content for {title} will be implemented here...
          </Text>
        </Card>
      </VStack>
    </Box>
  );
} 